var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content self_c"},[_c('headNav',{attrs:{"back":true,"color":"#56AC9A"}}),_vm._v(" "),_c('div',{staticClass:"self_b"},[_c('iframe',{style:('min-height:' + _vm.window_.wh + 'px;'),attrs:{"src":(_vm.origin + "/advert_item_list.html?advertId=" + _vm.id)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69189740","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/brand/ad.vue
// module id = null
// module chunks = 